import React from "react";
import { Game } from "@nestcoinco/hyper-api-gateway-api-client";
import { useSetAtom } from "jotai";
import { useQueryClient } from "@tanstack/react-query";

import "./GamesListSection.scss";
import GameTile from "../../GameTile/GameTile";
import GamesListLoadingSkeleton from "./GamesListLoadingSkeleton";
import { gameDetailsDrawerSlugAtom } from "../../../../jotai/atoms/games";
import useSubscription from "../../../../react-query/queries/use-subscription-status";
import { QUERY_KEYS } from "../../../../react-query/constants";

interface GamesListSectionProps {
  title: string;
  games: Game[];
  isLoading: boolean;
  tileLabel?: string;
}

function GamesListSection({
  title,
  games,
  isLoading,
  tileLabel,
}: GamesListSectionProps) {
  const queryClient = useQueryClient();
  const setDrawerSlug = useSetAtom(gameDetailsDrawerSlugAtom);
  const { gateAction } = useSubscription();

  const openDrawer = (game: Game) => {
    if (!game.slug) return;

    gateAction(() => {
      queryClient.setQueryData([QUERY_KEYS.GAME.GAME_DETAILS, game.slug], game);
      setDrawerSlug(game.slug!);
    });
  };

  if (isLoading) return <GamesListLoadingSkeleton />;

  if (!games.length) return null;

  return (
    <section className="games-list-section px-3">
      <h2 className="heading">{title}</h2>
      <div className="games-list-container">
        {games.map((game) => (
          <GameTile
            key={game.slug}
            name={game.name}
            slug={game.slug}
            thumbnail={game.thumbnail}
            playCount={game.playCount}
            tileLabel={tileLabel}
            onClick={() => openDrawer(game)}
          />
        ))}
      </div>
    </section>
  );
}

export default GamesListSection;
